import { Injectable } from "@angular/core";
import { IWidget } from "app/_models/IWidget";
import { IWidgetRow } from "app/_models/IWidgetRow";
import { CommunicationService } from "app/_services/communication.service";

@Injectable({ providedIn: 'root' })
export class WidgetController {
    constructor() { }

    buildWidgetRows(widgetData: IWidget[], maximised: boolean): IWidgetRow[][] {
        let rowMap: { [row: number]: IWidgetRow[] } = {};

        widgetData.forEach(widget => {
            let parts = !maximised ? widget.compactPosition.split(',') : widget.expandedPosition.split(',');
            let row = parseInt(parts[0], 10);
            let col = parts[1] ? parseInt(parts[1], 10) : 1;
            let span = parts[2] ? parseInt(parts[2], 10) : 1;
            let item = { row, col, span, widget, width: '12', offset: '' };
            if (!rowMap[row]) rowMap[row] = [];
            rowMap[row].push(item);
        });

        Object.keys(rowMap).forEach(rowKey => {
            let rowItems = rowMap[+rowKey];
            rowItems.sort((a, b) => a.col - b.col);
        });

        let rows = Object.keys(rowMap).map(r => +r).sort((a, b) => a - b).map(row => rowMap[row]);
        rows.forEach(row => this.computeRowLayout(row, maximised));
        return rows;
    }

    computeRowLayout(row: IWidgetRow[], maximised: boolean): void {
        let totalCols = Math.max(...row.map(x => x.col + x.span - 1));
        let prevEnd = 0;
        row.forEach(item => {
            let gridOffset = item.col - prevEnd - 1;
            let offset = gridOffset > 0 ? gridOffset : 0;
            item.width = !maximised ? `col-${((item.span / totalCols) * 12).toString()}` : ((item.span / totalCols) * 12).toString();
            item.offset = !maximised ? `offset-${((offset / totalCols) * 12).toString()}` : ((offset / totalCols) * 12).toString();
            prevEnd = item.col + item.span - 1;
        });
    }
}